module.exports = __webpack_public_path__ + "fonts/mem8YaGs126MiZpBA-UFVZ0b.33543c5c.woff2";